import { Entity, Field } from "typegraph";

@Entity({ one: 'certificate', many: 'certificates' })
export default class Certificate {

	@Field()
	public id: number;

	@Field()
	public name: string;

}



// WEBPACK FOOTER //
// ./src/panels/userCertificates/entities/Certificate.ts